import { Stack, Typography } from '@mui/material';

import { ReactComponent as CloseIcon } from 'common/assets/images/close.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';
import {
	PRC_BUTTON_TEXT,
	PRC_REMOVE_ENTITY_MODAL_TEXT,
	PRC_SUBMIT_CHANGES_MODAL_TEXT,
	SUBMIT_CHANGES_MODAL_TYPE,
} from 'common/constants/TaxonomyConstants';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { ISubmitChangesModal } from '../api/type-def';

import styles from './MetaDataEditModal.module.scss';

const { CANCEL, SUBMIT: SUBMIT_LABEL, REMOVE } = PRC_BUTTON_TEXT;
const { SUBMIT } = SUBMIT_CHANGES_MODAL_TYPE;
const { MODAL_SUBTITLE: SUBMIT_SUBTITLE, MODAL_TITLE: SUBMIT_TITLE } =
	PRC_SUBMIT_CHANGES_MODAL_TEXT;
const { MODAL_SUBTITLE: REMOVE_SUBTITLE, MODAL_TITLE: REMOVE_TITLE } =
	PRC_REMOVE_ENTITY_MODAL_TEXT;

const SubmitChangesModal = (props: ISubmitChangesModal) => {
	const {
		modalType,
		isModalOpen,
		modalCloseHandler,
		isSubmitting,
		submitDataHandler,
	} = props;
	const subtitle = modalType === SUBMIT ? SUBMIT_SUBTITLE : REMOVE_SUBTITLE;
	const title = modalType === SUBMIT ? SUBMIT_TITLE : REMOVE_TITLE;

	return (
		<ModalEle
			open={isModalOpen}
			handleClose={modalCloseHandler}
			restrictDefaultCloseAction
			sxBoxProps={{
				width: '30%',
				margin: 'auto',
			}}
		>
			<Stack
				className={styles['data-container']}
				onMouseDown={(event) => event.stopPropagation()}
				onClick={(event) => event.stopPropagation()}
				data-testid="modal-container"
			>
				<Typography className={styles['modal-title']}>
					{toSentenceCase(title)}
				</Typography>
				<CloseIcon
					fontSize="medium"
					onClick={modalCloseHandler}
					className={`${styles['add-closemodal']} ${
						isSubmitting ? styles['disable-btn'] : ''
					}`}
					data-testid="close-icon"
				/>
			</Stack>
			<Typography className={styles['submit-modal-subtitle']}>
				{subtitle}
			</Typography>
			<Stack className={styles['button-container']}>
				<ButtonComp
					btnType="secondary"
					clickHandler={modalCloseHandler}
					data-testid="cancel-btn"
					disabled={isSubmitting}
				>
					{toSentenceCase(CANCEL)}
				</ButtonComp>
				<ButtonComp
					clickHandler={() => submitDataHandler()}
					btnType="primary"
					data-testid="submit-btn"
					loading={isSubmitting}
				>
					{toSentenceCase(modalType === SUBMIT ? SUBMIT_LABEL : REMOVE)}
				</ButtonComp>
			</Stack>
		</ModalEle>
	);
};

export default SubmitChangesModal;
